import { useState, useEffect, useRef } from 'react'

const RenderIfVisible = ({ children, estimatedHeight, ...elemProps}) => {

    const [visible, setVisible] = useState(false)
    const elemRef = useRef()

    useEffect(() => {

        let observer;

        if (window.IntersectionObserver) {
            observer = new IntersectionObserver( entries => {
                entries.forEach(entry => {
                    if ( entry.intersectionRatio > 0 || entry.isIntersecting ) {
                        setVisible(true)
                        observer.unobserve(entry.target)
                    }
                })
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.001,
            })

            if (elemRef.current) {
                observer.observe(elemRef.current);
            }
        } 
        else {
            /* Old browsers fallback */
            setVisible(true)
        }
        
        const cleanUpEl = elemRef.current;
        return () => {
            /* on component cleanup, we remove the listener */
            if (observer && observer.unobserve && cleanUpEl) {
                observer.unobserve(cleanUpEl)
            }
        }
    }, [elemRef])

    return (
        <div ref={elemRef} {...elemProps}>
            {visible 
                ? children 
                : (
                <div style={{ height: estimatedHeight }} />
            )}
        </div>
    );
}

export default RenderIfVisible;